import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

// ต้อง register components ของ Chart.js ก่อนใช้งาน
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ namedapartlist ,Totallist}) => {
    // console.log(namedapartlist)
    const data = {
        // labels: ["planning", "prepress", "rd", "couting", "printing", "fg1", "rd"],
        labels: namedapartlist,
        datasets: [
            {
                label: "เอกสาร",
                // data: [30, 50, 40, 60, 70, 50, 10, 60],
                data:Totallist,
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                    'rgba(255, 205, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(201, 203, 207, 0.2)',
                    'rgba(255, 159, 64, 0.2)'
                ],
                borderColor: [
                    'rgb(255, 99, 132)',
                    'rgb(255, 159, 64)',
                    'rgb(255, 205, 86)',
                    'rgb(75, 192, 192)',
                    'rgb(54, 162, 235)',
                    'rgb(153, 102, 255)',
                    'rgb(201, 203, 207)',
                    'rgb(255, 159, 64)'
                ],
                // backgroundColor: "rgba(75, 192, 192, 0.5)",
                // borderColor: "rgba(75, 192, 192, 1)",
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "เอกสารที่รับผิดชอบตามแผนก",
            },
        },
    };

    return <Bar data={data} options={options} />;
};

export default BarChart;
